/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".checkbox[_ngcontent-%COMP%]{cursor:pointer;overflow:hidden;width:25px;height:26px}.checkbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{display:none}.checkbox[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]{position:relative;width:25px;height:25px;background:#fff;border:2px solid #f0f0f0;border-radius:5px;font-size:14px;display:inline-block;text-align:center}.checkbox[_ngcontent-%COMP%]   .checkmark.checked[_ngcontent-%COMP%]{border:2px solid #0a145a}"];
export { styles as styles };
